import useSWR from 'swr';
import { apiBaseURL } from '../../Utils/ProjectConstants';

export default function useGetReceipts(orderId) {

    const { data, error, mutate } = useSWR(`${apiBaseURL}/api/Receipt?orderId=${orderId}`, {
        //onSuccess: (data) => console.log('Receipts fetched successfully:', data?.data),
        revalidateOnFocus: false,
        dedupingInterval: 300000,
    });

    const
        receiptData = data?.data.filter(x => x.fileType === 0),
        quoteData = data?.data.filter(x => x.fileType === 1);

    return {
        receiptData,
        quoteData,
        error,
        mutate,
    }
}